const DESCRICAO_MARKER = / - Descrição: /i;
const SERVICO_BLOCK_SPLIT = /(?=Serviço:)/i;

/**
 * Quebra o texto do campo servico em blocos para exibição na tabela.
 * Formato esperado por bloco: "Serviço: N- Prioridade X - Descrição Y"
 */
export const parseServicoBlocks = (servico) => {
  if (!hasServicoText(servico)) return [];

  const text = String(servico).trim();
  const rawBlocks = text
    .split(SERVICO_BLOCK_SPLIT)
    .map((block) => block.trim())
    .filter(Boolean);

  return rawBlocks.map((block) => {
    const match = DESCRICAO_MARKER.exec(block);
    if (!match) {
      return { header: block, description: null };
    }

    const header = block.slice(0, match.index).trim();
    const descValue = block.slice(match.index + match[0].length).trim();

    return {
      header,
      description: descValue ? `Descrição ${descValue}` : null,
    };
  });
};

export const hasServicoText = (servico) =>
  servico != null && String(servico).trim() !== '';

export const shouldFormatServicoDisplay = (servico) => {
  const blocks = parseServicoBlocks(servico);
  return blocks.some((block) => block.description);
};
